export default {
  getCart: state => {
    return state.cartlist
  },
  getActivityItem: state => {
    return state.activityitem
  }
}



// WEBPACK FOOTER //
// ./src/store/cart/getters.js